// extracted by mini-css-extract-plugin
export default {"support-bage":"SupportBage_support-bage__wZSAQ","support-bage-title":"SupportBage_support-bage-title__NWOuA"};